import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../shared';
import { WeatherContainerModel } from '../../../../../models/aggregates/weather';

@Injectable({
  providedIn: 'root'
})
export class WeatherService extends BaseApiTemplateService<WeatherContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.DATALIB_PREFIX + 'weather/public-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.DATALIB_PREFIX + 'weather/public-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.DATALIB_PREFIX + 'weather/public-ep';
    this.httpClient = http;
  }
}